import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";
import { motion } from "framer-motion";

const NavBar = () => {
  const [nav, setNav] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 8);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = [
    { id: 1, link: "home", label: "Home" },
    { id: 2, link: "career", label: "Experience" },
    { id: 3, link: "about", label: "About" },
    { id: 4, link: "projects", label: "Projects" },
    { id: 5, link: "experience", label: "Skills" },
    { id: 6, link: "contact", label: "Contact" },
  ];

  const navVariants = {
    hidden: { opacity: 0, y: -12 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.06,
        delayChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -12 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.25 },
    },
  };

  return (
    <motion.header
      className={`flex justify-between items-center w-full h-[4.25rem] px-4 sm:px-8 text-white fixed z-50 transition-all duration-300 ${
        scrolled
          ? "bg-slate-950/85 backdrop-blur-xl border-b border-white/[0.06] shadow-sm shadow-black/20"
          : "bg-transparent"
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.45 }}
    >
      <motion.div whileHover={{ opacity: 0.9 }} whileTap={{ scale: 0.98 }} className="flex items-center gap-3">
        <Link to="home" smooth duration={500} className="flex items-center gap-3 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-sky-500/20 to-sky-600/10 ring-1 ring-sky-500/30 text-xs font-bold tracking-tight text-sky-400">
            MN
          </span>
          <div className="leading-tight">
            <span className="block text-sm font-semibold text-white tracking-tight">Muhammed Nasmi</span>
            <span className="hidden sm:block text-[11px] text-slate-500 font-medium">Full Stack Developer</span>
          </div>
        </Link>
      </motion.div>

      <motion.ul
        className="hidden md:flex items-center gap-1 lg:gap-2"
        initial="hidden"
        animate="visible"
        variants={navVariants}
      >
        {links.map(({ id, link, label }) => (
          <motion.li key={id} variants={itemVariants} className="relative">
            <Link
              to={link}
              smooth
              duration={500}
              offset={-10}
              className="text-[13px] font-medium text-slate-400 hover:text-white transition-colors px-3 py-2 rounded-md hover:bg-white/[0.04]"
              activeClass="text-sky-400 !text-sky-400 bg-white/[0.06]"
              spy={true}
            >
              {label}
            </Link>
          </motion.li>
        ))}
      </motion.ul>

      <motion.button
        type="button"
        aria-label={nav ? "Close menu" : "Open menu"}
        onClick={() => setNav(!nav)}
        className="cursor-pointer z-50 md:hidden p-2 rounded-lg text-slate-300 hover:text-white hover:bg-white/5 transition-colors"
        whileTap={{ scale: 0.95 }}
      >
        {nav ? <FaTimes className="text-sky-400 text-xl" /> : <FaBars className="text-xl" />}
      </motion.button>

      {nav && (
        <motion.div
          className="fixed inset-0 bg-slate-950/96 backdrop-blur-md flex flex-col items-center justify-center z-40 md:hidden"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
        >
          <motion.ul
            className="flex flex-col items-center gap-6"
            initial="hidden"
            animate="visible"
            variants={navVariants}
          >
            {links.map(({ id, link, label }) => (
              <motion.li key={id} variants={itemVariants}>
                <Link
                  onClick={() => setNav(false)}
                  to={link}
                  smooth
                  duration={500}
                  offset={-10}
                  className="text-lg font-medium text-slate-300 hover:text-sky-400 transition-colors px-4 py-2"
                  activeClass="text-sky-400"
                  spy={true}
                >
                  {label}
                </Link>
              </motion.li>
            ))}
          </motion.ul>
        </motion.div>
      )}
    </motion.header>
  );
};

export default NavBar;
